import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { FaRegCirclePlay } from 'react-icons/fa6';

interface VideoGridProps {
  iconSize?: string;
  videoTitle: string;
  src: string;
  href: string;
  blurDataURL: string;
}

export default function VideoGrid({
  iconSize,
  videoTitle,
  src,
  href,
  blurDataURL,
}: VideoGridProps) {
  return (
    <div className="videoHolder">
      <Link href={href} aria-label={`Watch video: ${videoTitle}`}>
        <div className="videoPlaceholder">
          <Image
            src={src}
            alt={videoTitle}
            width={400}
            height={250}
            quality={100}
            sizes="(max-width: 767px) 100vw, 50vw"
            placeholder="blur"
            blurDataURL={blurDataURL}
          />
          <span
            className="playIcon"
            style={{ fontSize: iconSize }}
            aria-hidden="true"
          >
            <FaRegCirclePlay />
          </span>
        </div>
        <h3>{videoTitle}</h3>
      </Link>
    </div>
  );
}
